@switch (role) {
  @case ('owner') {
    <a class="zef-text-p2-link" routerLink="/settings/users">
      <strong class="zef-color-owner" i18n>Owner</strong>
    </a>
  }
  @case ('admin') {
    <a class="zef-text-p2-link" routerLink="/settings/users">
      <strong class="zef-color-admin" i18n>Admin</strong>
    </a>
  }
  @case ('member') {
    <span class="zef-text-p2 zef-color-member" i18n>Member</span>
  }
}
